<kendo-grid
    #grid
    [isBusy]="isBusy"
    [data]="itemsGridView"
    [skip]="filter.offset"
    [pageSize]="filter.pageSize"
    [pageable]="pagingOptions"
    [sort]="sortsArr"
    [loading]="isBusy"
    [sortable]="{ allowUnsort: true }"
    [resizable]="true"
    [rowClass]="rowCallback"
    (pageChange)="pageChange($event)"
    (sortChange)="sortChange($event)"
    (cellClick)="openDialogExpandChatNote($event)">
    <ng-template kendoGridToolbarTemplate>
        <div class="d-flex justify-content-between align-items-center w-100">
            @if (hasPermission('Chat.Chat.CreateAndSearch') && !canAddNewNote) {
                <button class="btn btn-sm btn-primary" (click)="openDialogAddNewChatNote()">
                    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                </button>
            }
            <small class="text-muted">
                <fa-icon class="text-info me-1" [icon]="['fas', 'info-circle']"></fa-icon>
                {{ 'Click on any row to view message details' | translate }}
            </small>
        </div>
    </ng-template>
    <kendo-grid-column title="{{ 'Received' | translate }}" field="createdDate" [width]="70">
        <ng-template kendoGridCellTemplate let-row>
            <div class="chat-date">{{ row.createdDate | date: 'dd.MM.yyyy HH:mm' }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{ 'Sender' | translate }}" field="createdBy.lastName" [width]="170">
        <ng-template kendoGridCellTemplate let-row>
            <div class="sender-display d-flex align-items-center">
                <div class="user-avatar-small mr-1">
                    {{
                        this.getUserInitials(
                            $safeNavigationMigration(row.createdBy?.firstName) +
                                ' ' +
                                $safeNavigationMigration(row.createdBy?.lastName)
                        )
                    }}
                </div>
                <div class="sender-info">
                    <div class="sender-name">
                        {{ row.createdBy?.firstName + ' ' + row.createdBy?.lastName }}
                    </div>
                    <div class="sender-org">{{ row.createdByOrganization?.name }}</div>
                </div>
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{ 'Subject' | translate }}" field="remark" [width]="240">
        <ng-template kendoGridCellTemplate let-row>
            <div class="subject-text">
                {{ row.remark }}
            </div>
        </ng-template>
    </kendo-grid-column>
    @if (mode === ChatMode.VesselVisit && !vesselVisitId) {
        <kendo-grid-column field="vesselVisitId" title="{{ 'Vessel Visit' | translate }}" [width]="100">
            <ng-template kendoGridCellTemplate let-row>
                <a
                    class="row-link"
                    [routerLink]="['/vessel-visit/visit/edit', row.vesselVisitId]"
                    [queryParams]="{ tab: '8' }">
                    {{ row.vesselVisitId }}
                </a>
            </ng-template>
        </kendo-grid-column>
    }
    @if (mode === ChatMode.ServiceRequest && !serviceRequestId) {
        <kendo-grid-column field="serviceRequestId" title="{{ 'Service Request' | translate }}" [width]="100">
            <ng-template kendoGridCellTemplate let-row>
                <a
                    class="row-link"
                    [routerLink]="['/tos-operations/service-request/edit', row.serviceRequestId]"
                    [queryParams]="{ tab: '9' }">
                    {{ row.serviceRequestId }}
                </a>
            </ng-template>
        </kendo-grid-column>
    }
    @if (mode === ChatMode.StorageDocument && !storageDocumentId) {
        <kendo-grid-column field="storageDocumentId" title="{{ 'Storage Document' | translate }}" [width]="100">
            <ng-template kendoGridCellTemplate let-row>
                <a
                    class="row-link"
                    [routerLink]="['/tos-operations/storage-document/edit', row.storageDocumentId]"
                    [queryParams]="{ tab: '5' }">
                    {{ row.storageDocumentId }}
                </a>
            </ng-template>
        </kendo-grid-column>
    }
    @if (mode === ChatMode.AmendmentDocument && !amendmentDocumentId) {
        <kendo-grid-column field="amendmentDocumentId" title="{{ 'Amendment Document' | translate }}" [width]="100">
            <ng-template kendoGridCellTemplate let-row>
                <a
                    class="row-link"
                    [routerLink]="['/tos-operations/amendment-document/edit', row.amendmentDocumentId]"
                    [queryParams]="{ tab: '4' }">
                    {{ row.amendmentDocumentId }}
                </a>
            </ng-template>
        </kendo-grid-column>
    }
    <kendo-grid-column field="isNew" title="" [style]="{ 'text-align': 'center' }" [width]="30">
        <ng-template kendoGridCellTemplate let-row>
            <div class="recipient-display d-flex align-items-center">
                @if (row.isNew) {
                    <fa-icon
                        class="text-primary mr-2"
                        kendoTooltip
                        size="lg"
                        title="Unread Message"
                        [icon]="['fas', 'envelope']"></fa-icon>
                }
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{ 'Recipient' | translate }}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <div class="recipient-display d-flex align-items-center">
                <fa-icon
                    class="mr-2"
                    kendoTooltip
                    [icon]="getRecipientInfo(row).icon"
                    [title]="getRecipientInfo(row).tooltip"></fa-icon>
                <div class="recipient-text">
                    <div class="recipient-name">{{ getRecipientInfo(row).text }}</div>
                    @if (getRecipientInfo(row).showTypeInfo) {
                        <div class="recipient-type">
                            <fa-icon
                                class="type-indicator me-1"
                                kendoTooltip
                                [icon]="getChatTypeIcon($safeNavigationMigration(row.chatNoteType?.localizedCode)).icon"
                                [ngClass]="
                                    getChatTypeBadgeClass($safeNavigationMigration(row.chatNoteType?.localizedCode))
                                "
                                [title]="
                                    getChatTypeIcon($safeNavigationMigration(row.chatNoteType?.localizedCode)).tooltip
                                "></fa-icon>
                            <small class="text-muted">
                                {{ getChatTypeIcon($safeNavigationMigration(row.chatNoteType?.localizedCode)).tooltip }}
                            </small>
                        </div>
                    }
                </div>
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="viewDate" title="" [style]="{ 'text-align': 'center' }" [width]="30">
        <ng-template kendoGridCellTemplate let-row>
            <div class="recipient-display d-flex align-items-center">
                @if (row.viewDate && row.createdBy?.id === this.user?.id) {
                    <fa-icon
                        class="text-success mr-2"
                        kendoTooltip
                        size="lg"
                        [title]="
                            ('All recipients read on' | translate) + ' ' + (row.viewDate | date: 'dd.MM.yyyy HH:mm')
                        "
                        [icon]="['fas', 'check-double']"></fa-icon>
                }
            </div>
        </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
        <div class="text-center p-4">
            <fa-icon class="text-muted mb-3" size="3x" [icon]="['fas', 'comments']"></fa-icon>
            <p class="text-muted">{{ 'No chat messages available' | translate }}.</p>
        </div>
    </ng-template>
</kendo-grid>

@if (dialogAddNewChatNoteOpen) {
    <kendo-dialog title="{{ 'Add New Note' | translate }}" [minWidth]="1250" (close)="closeDialogAddNewChatNote()">
        <app-chat-window-new-note
            [vesselVisitId]="vesselVisitId"
            [serviceRequestId]="serviceRequestId"
            [storageDocumentId]="storageDocumentId"
            [amendmentDocumentId]="amendmentDocumentId"
            [mode]="mode"
            (closeModal)="closeDialogAddNewChatNoteEvent($event)"></app-chat-window-new-note>
    </kendo-dialog>
}
@if (dialogExpandChatNote) {
    <div class="chat-expand-overlay">
        <app-chat-window-expand-note
            [openNoteId]="openedNoteId"
            [isNew]="isNew"
            (closeModal)="closeDialogExpandChatNoteEvent($event)"></app-chat-window-expand-note>
    </div>
}
